import React from "react";
import { Switch, Route } from "react-router-dom";
import LabelAdministration from "./LabelAdministration";
import AdminIndex from "./AdminIndex";
import FreightHandlingCodeAdministration from "./FreightHandlingCodeAdministration";
import CarrierDetailAdministration from "./CarrierDetailAdministration";
import NewsAdministration from "./NewsAdministration";
import WarrantyAllowanceAdministration from "./WarrantyAllowanceAdministration";
import DashboardComponentAdministration from "./DashboardComponentAdministration";
import PIMProductAdministration from "./PIMProductAdministration";
import DomesticCountriesAdministration from "./domestic-countries-administration";
import ItemRestrictionAdministration from "./ItemRestrictionAdministration";
import ProductSalesCodeAdministration from "./ProductSalesCodeAdministration";
import BranchAdministration from "./BranchAdministration";
import OptionalOrderTypeAdministration from "./OptionalOrderTypeAdministration";
export default function StorefrontAdministration(parentProps) {
    return (
        <Switch>
            <Route
                exact
                path={["/storefront-administration/label-administration"]}
                render={(props) => <LabelAdministration {...parentProps} {...props} />}
            />

            <Route
                exact
                path={[
                    "/storefront-administration/freight-handling-code-administration",
                ]}
                render={(props) => (
                    <FreightHandlingCodeAdministration {...parentProps} {...props} />
                )}
            />

            <Route
                exact
                path={["/storefront-administration/carrier-detail-administration"]}
                render={(props) => (
                    <CarrierDetailAdministration {...parentProps} {...props} />
                )}
            />

            <Route
                exact
                path={["/storefront-administration/news-administration"]}
                render={(props) => <NewsAdministration {...parentProps} {...props} />}
            />

            <Route
                exact
                path={["/storefront-administration/warranty-allowance-administration"]}
                render={(props) => (
                    <WarrantyAllowanceAdministration {...parentProps} {...props} />
                )}
            />

            <Route
                exact
                path={["/storefront-administration/dashboard-component-administration"]}
                render={(props) => (
                    <DashboardComponentAdministration {...parentProps} {...props} />
                )}
            />

            <Route
                exact
                path={["/storefront-administration/pim-product-administration"]}
                render={(props) => (
                    <PIMProductAdministration {...parentProps} {...props} />
                )}
            />

            <Route
                exact
                path={["/storefront-administration/domestic-countries"]}
                render={(props) => (
                    <DomesticCountriesAdministration {...parentProps} {...props} />
                )}
            />

            <Route
                exact
                path={[
                    "/storefront-administration/index",
                    "/storefront-administration",
                ]}
                render={(props) => <AdminIndex {...parentProps} {...props} />}
            />
            <Route
                exact
                path={[
                    "/storefront-administration/item-restriction",
                ]}
                render={(props) => (
                    <ItemRestrictionAdministration {...parentProps} {...props} />
                )}
            />
            <Route
                exact
                path={["/storefront-administration/product-sales-code-administration"]}
                render={(props) => (
                    <ProductSalesCodeAdministration {...parentProps} {...props} />
                )}
            />
            <Route
                exact
                path={[
                    "/storefront-administration/branch-admin",
                ]}
                render={(props) => (
                    <BranchAdministration {...parentProps} {...props} />
                )}
            /> 
            <Route
                exact
                path={["/storefront-administration/optional-order-type-administration"]}
                render={(props) => (
                    <OptionalOrderTypeAdministration {...parentProps} {...props} />
                )}
            />
        </Switch>
    );
}
